// Pure list-reordering helpers used by the stage drag-and-drop in both the
// schedule creator (CrewSchedule) and the read-only producer Schedule page.
// Kept dependency-free so it can be unit-tested in isolation and shared.

/** Move the item at `fromIndex` to `toIndex`, returning a new array. */
export function moveItem<T>(items: T[], fromIndex: number, toIndex: number): T[] {
  const next = items.slice();
  if (
    fromIndex === toIndex ||
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= items.length ||
    toIndex >= items.length
  ) {
    return next;
  }
  const [moved] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, moved);
  return next;
}

/**
 * Reorder a list of stage ids by moving `draggedId` to the position currently
 * held by `targetId`. Returns a new array; if either id is missing the input
 * order is preserved (defensive — a stale drag shouldn't scramble the list).
 */
export function reorderIds(ids: string[], draggedId: string, targetId: string): string[] {
  const from = ids.indexOf(draggedId);
  const to = ids.indexOf(targetId);
  if (from === -1 || to === -1) return ids.slice();
  return moveItem(ids, from, to);
}
